import React, { useCallback, useEffect, useRef } from 'react';
import { Menu } from 'antd';
import { UserOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons'; // Импорт иконок
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../redux/actions/authActions';
import { useNavigate } from 'react-router-dom';
import { toggleUserProfile } from '../../redux/actions/profileActions';
import useIsMobile from '../../hooks/useIsMobile';

// Зависящий от isMobile стиль строится в компоненте: раньше isMobile считался
// один раз при загрузке модуля и не реагировал на resize
const profileDropdownStyle = (isMobile) => ({
    position: 'absolute',
    right: isMobile ? '0px' : '20px',
    top: isMobile ? '42px' : '32px',
    backgroundColor: 'white',
    borderRadius: isMobile ? '0px' : '16px',
    padding: '10px',
    height: isMobile ? 'calc(100vh - 52px)' : 'auto',
    overflowY: 'auto',
});

const styles = {
    userInfo: {
        paddingBottom: '10px',
        padding: '10px',
        marginBottom: '10px',
        borderBottom: '2px dashed #e0e0e0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    username: {
        fontWeight: 'bold',
        color: '#333',
        marginBottom: '5px',
    },
    email: {
        color: '#555',
        fontSize: '0.9rem',
    },
};

function UserProfile() {
    const isMobile = useIsMobile();
    const { familyName, givenName, email } = useSelector(state => state.profile);
    const dispatch = useDispatch();
    const ref = useRef(null);

    const navigate = useNavigate();

    // useCallback, чтобы снять и повесить слушатель можно было по той же ссылке:
    // без него каждый рендер создавал новый обработчик, и removeEventListener в очистке
    // снимал бы не тот, который вешал
    const handleClickOutside = useCallback((event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            dispatch(toggleUserProfile());
        }
    }, [dispatch]);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);

    const handleActionClick = (action) => {
        if (action === 'logout') {
            localStorage.clear();
            dispatch(logout());
        }
        if (action === 'profile') {
            navigate('/profile');
        }
        dispatch(toggleUserProfile());
    };

    return (
        <div ref={ref} style={profileDropdownStyle(isMobile)}>
            <div style={styles.userInfo}>
                <div style={styles.username}>{givenName} {familyName}</div>
                <div style={styles.email}>{email}</div>
            </div>
            <Menu
                style={{ borderInline: 'none' }}
                selectable={false}
                mode="vertical"
                onClick={({ key }) => handleActionClick(key)}
            >
                <Menu.Item key="profile" icon={<UserOutlined />}>
                    Profile
                </Menu.Item>
                <Menu.Item key="settings" icon={<SettingOutlined />}>
                    Settings
                </Menu.Item>
                <Menu.Item key="logout" icon={<LogoutOutlined />}>
                    Logout
                </Menu.Item>
            </Menu>
        </div>
    );
}

export default UserProfile;
